import $ from 'zepto';
var backDiv = null,
    popDiv = null;

var msgbox_tpl = require('../tpl/msgbox.tpl');
var active_cfg = window.active_cfg;

function msgbox(msg, opts) {
    msgbox.exit();
    opts = opts || {};
    var popDiv = createpopDiv();
    var btn_title = (opts.btn_title) || '确定';
    var btn_class = (opts.btn_class) || '';
    var btn_payid = (opts.btn_payid) || '';
    var btn_fn = (opts.btn_fn) || '';

    if (btn_payid) {
        btn_payid = 'payid="' + btn_payid + '"';
    }
    if (btn_fn) {
        opts.btn_href = opts.btn_href || 'javascript:;'
    }
    var btn_href = (opts.btn_href) || 'javascript:msgExit()';
    var btn_target = (opts.btn_target == 1) ? '_blank' : '';
    var clickid = (opts.clickid) || "";
    popDiv.find("[name=msgbox_info]").html(msg);
    var btn = popDiv.find('[name=box_btn]');
    btn.replaceWith('<a class="btn_pop btn_ok ' + btn_class + '" ' + clickid + ' ' + btn_payid + ' href="' + btn_href + '" name="box_btn" title="' + btn_title + '" target="' + btn_target + '">' + btn_title + '</a>');;
    btn_fn && popDiv.find('[name=box_btn]').on('click', btn_fn);
    if (opts['close_href']) {
        var btn = popDiv.find('a.act_close_box');
        btn.replaceWith('<a href="' + opts['close_href'] + '" title="关闭" class="act-pop-close act_close_box">关闭</a>');
    }
    msgbox.id = 'act_msgbox_common';
    popDiv.show();
};

msgbox.show = function(id, opts) {
    msgbox.exit();
    opts = opts || {};
    if (opts.only) {
        backDiv = $('<div style="position:fixed;z-index:998;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.4);"></div>').appendTo('body');
        popDiv = $('#' + id).show();
        msgbox.id = id;
        return
    }
    if ($('#' + id).hasClass('cover')) {
        $('#' + id).show();
    } else {
        let _id = id + '_cover';
        if ($('#' + _id).size()) {
            $('#' + _id).show();
        } else {
            if($('#' + id).size() <= 0){
                return;
            }
            var $popDiv = $('<div class="cover" id="' + _id + '"></div>');
            $popDiv.append($('#' + id).show()).appendTo('body');
            $popDiv.show();
        }

        id = _id;
    }
    msgbox.id = id;
};

msgbox.exit = function(id, opts) {
    $('#' + msgbox.id).hide();
    if (backDiv) {
        backDiv.remove();
        backDiv = null;
    }
};

function createpopDiv() {
    var popDiv = null;
    $('#act_msgbox_common').length ? popDiv = $('#act_msgbox_common') : popDiv = $(msgbox_tpl).appendTo('body');
    return popDiv;
}

msgbox.showErrorMsg = function(MSGID, opts) {
    if (active_cfg && active_cfg['msg']) {
        var MSG = active_cfg['msg'][MSGID];
    }
    var opts = opts;
    if (MSG) {
        opts = {
            btn_title: MSG['btn_text'],
            btn_href: MSG['btn_link'],
            btn_target: MSG['btn_action'],
            boxTitle: MSG['title'],
            btn_class: MSG['btn_class'],
            btn_payid: MSG['btn_payid']
        };
        msgbox(MSG['content'], opts);
    } else {
        msgbox(MSGID, opts);
    }
}

window.msgExit = msgbox.exit

export default msgbox;



// WEBPACK FOOTER //
// ./src/common/msgbox.js